import FactTab from './FactTab';

export default FactTab;
